import { createSelector } from '@reduxjs/toolkit';

import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import { isRuleValid } from 'src/containers/ProjectDiagram/utils/rules/isRuleValid';
import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectRuleModelSelector } from 'src/selectors/projectRuleModel';

export const projectRulesByIdSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      diagramSnapshotSelector(projectId),
      (diagram) => diagram?.model.modelData.rulesById || {}
    )
);

export const prevProjectRulesByIdSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      diagramSnapshotSelector(projectId),
      (diagram) => diagram?.model.modelData.draftData?.prevModelData.rulesById
    )
);

export const projectRuleSelector = memoizeSelectorFactory(
  (projectId: string, ruleId: string) =>
    createSelector(
      projectRulesByIdSelector(projectId),
      (rulesById): ModelRule | null => rulesById[ruleId] || null
    )
);

/**
 * @returns set of rule ids that are invalid
 */
export const projectInvalidRulesByIdSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectRulesByIdSelector(projectId),
      projectRuleModelSelector(projectId),
      (rulesById, validModel) =>
        Object.fromEntries(
          Object.entries(rulesById).filter(
            ([_, rule]) => !isRuleValid(rule, validModel)
          )
        )
    )
);
